import { PlaceMedia } from './PlaceMedia';
import { getPlaceMedia } from './livingSpaceData';
import styles from './LivingSpace.module.scss';

export function LivingSpace() {
  return (
    <section className={styles.section} id="territory" aria-labelledby="territory-title">
      <div id="utilities" className={styles.compatibilityAnchor} aria-hidden="true" />
      <div className={styles.inner}>
        <header className={styles.intro} data-reveal>
          <div>
            <p className={styles.eyebrow}>Территория посёлка</p>
            <h2 id="territory-title">Что уже создано для жизни</h2>
          </div>
          <p className={styles.lead}>
            Комфорт загородной жизни зависит не только от дома. Важно, сколько пространства остаётся
            вокруг, насколько удобно передвигаться по посёлку и что находится за пределами
            собственного участка.
          </p>
        </header>

        <article className={styles.routeStory} data-reveal="media">
          <PlaceMedia media={getPlaceMedia('entrance')} className={styles.routeMedia} index="01" />
          <div className={styles.routeCopy}>
            <p className={styles.kicker}>Освещение и контролируемый въезд</p>
            <h3>Спокойный ежедневный маршрут</h3>
            <p>
              На территории установлено уличное освещение. Въезд в посёлок осуществляется через
              автоматические ворота, работают камеры видеонаблюдения.
            </p>
          </div>
        </article>

        <article className={styles.spaceStory} data-reveal="media">
          <div className={styles.spaceCopy}>
            <p className={styles.kicker}>Простор без тесной застройки</p>
            <h3>Место для дома и собственного сада</h3>
            <p>
              Площадь участков составляет от 10 до 20 соток. Здесь можно свободно разместить дом,
              парковку, террасу, сад и собственную зону отдыха.
            </p>
            <p className={styles.roadFact}>
              Ширина внутренних дорог — 6 метров, а их общая протяжённость составляет около 5
              километров.
            </p>
          </div>
          <PlaceMedia
            media={getPlaceMedia('vereskovaya-street')}
            className={styles.streetMedia}
            index="02"
          />
        </article>
      </div>

      <div className={styles.factBand}>
        <div className={styles.factBandInner}>
          <article className={styles.lakeBandStory} data-reveal="media">
            <PlaceMedia
              media={getPlaceMedia('lake-zone')}
              className={styles.lakeBandMedia}
              index="03"
            />
            <div>
              <p className={styles.kicker}>Собственное озеро</p>
              <h3>Пространство у воды</h3>
              <p>
                В центре посёлка находится собственное озеро. Вдоль берега
                создана территория для прогулок и спокойного отдыха у воды, благоустройство которой продолжается и по сей день.
              </p>
            </div>
          </article>

          <article className={styles.commonStory} data-reveal="media" data-reveal-delay="1">
            <PlaceMedia
              media={getPlaceMedia('playground')}
              className={styles.playgroundMedia}
              index="04"
            />
            <div>
              <p className={styles.kicker}>Общие пространства</p>
              <h3>Для прогулок и времени с детьми</h3>
              <p>
                В поселке оборудована детская площадка для малышей и детей постарше.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
